import Select from '../../../juristec-ui/core/SelectNew';
import { SelectOption } from '../../../types';

export interface plansData {
  [key: string]: SelectOption[];
}

interface SelectPlansProps {
  plans: plansData;
  states: plansData;
  setter: (selected: SelectOption[], key: string) => void;
}

const SelectPlans = ({
  plans, states, setter,
}: SelectPlansProps) => Object.entries(plans).map(([plan, instances]) => {
  if (instances.length <= 0) return null;
  const handleSetter = (selected: SelectOption[]) => setter(selected, plan);
  return (
    <Select
      key={`${plan}-select`}
      label={instances[0].planLabel}
      options={instances}
      placement="start"
      // @ts-expect-error Not typed yet
      value={states[plan] ?? []}
      onChange={handleSetter}
      multiple
      stayOpen
      atModal
      selectAll
      sortBy="ascending"
      searchable
    />
  );
});

export default SelectPlans;
